"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  d: "M10 5a1 1 0 0 1 1-1h4a.5.5 0 0 1 0 1h-1v1.085A1.5 1.5 0 0 1 15 7.5v1.585a1.5 1.5 0 0 1 1 1.415v9a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 19.5v-9a1.5 1.5 0 0 1 1-1.415V7.5a1.5 1.5 0 0 1 1-1.415zm.5 2a.5.5 0 0 0-.5.5V9h4V7.5a.5.5 0 0 0-.5-.5zM13 6V5h-2v1zm1.5 4h-5a.5.5 0 0 0-.5.5v.5h.5a2.5 2.5 0 0 1 2.5 2.5v3A2.5 2.5 0 0 1 9.5 19H9v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5M9 18h.5a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 9.5 12H9z",
  clipRule: "evenodd"
}), 'Foundation');
//# sourceMappingURL=index.js.map